import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from '../../services/user.service';
import { useForm } from "react-hook-form";

const NameModal = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {firstname: props.user.firstname, lastname: props.user.lastname, userId: props.user.id},
  });

  const onSubmit = async (data) => {
    await UserService.updateName(data);
    props.closeNameModal(false); 
  }

  const nameModalClose = () => {
    props.closeNameModal(false);
  }

  return (
    <Modal show={props.show} onHide={nameModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Name<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3" controlId="firstname">
                <Form.Label>First Name</Form.Label>
                <input {...register("firstname", { required: true })} /><br/>
                {errors.firstname && <div className="error" >First Name is required</div>}
              </Form.Group>
              <Form.Group className="mb-3" controlId="lastname">
                <Form.Label>Last Name</Form.Label>
                <input {...register("lastname", { required: true })} /><br/>
                {errors.lastname && <div className="error" >Last Name is required</div>}
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={nameModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
                  Update Name
                </Button>
              </Modal.Footer>
            </Form>  


    </Modal.Body>
    </Modal>
  );
};

export default NameModal; 